import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { fetchReviews } from "../../../actions/sticker_maker/stickerPacksActions";
import { fetchCategories } from "../../../actions/sticker_maker/categoriesActions";
import { useAppDispatch } from "../../../store/hooks";
import { queryParams } from "../../../helpers/UrlHelpers";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "./_partials/_PageHeader";
import List from "../StickerPacks/_partials/_List";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import MenuTags from "../Categories/_partials/_MenuTags";
import NewCategory from "../Categories/New";
import EditCategory from "../Categories/Edit";
import CategoriesSettings from "../Categories/Settings";
import ListViewButtons from "../../../componets/ListViewButtons";

const LIMIT = 42;
const DEFAULT_VIEW = 'list';

const PacksReviews = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const categoryIds     = queryParams.get(searchParams,'category_ids');
  const listType: any   = queryParams.get(searchParams,'view') || DEFAULT_VIEW;
  const orderByFilter   = {
    items: [
      { name: 'Date', key: 'id' },
      { name: 'Popular', key: 'popular_count' },
      { name: 'Likes', key: 'likes_count' },
      { name: 'Stickers', key: 'stickers_count' },
    ]
  };

  useEffect(() => {
    dispatch(fetchCategories({ target: 1 }));
  }, [dispatch]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (categoryIds) {
      params.category_ids = categoryIds?.split(',') || [];
    }

    dispatch(fetchReviews({ params, target: 'community' }));
  }, [categoryIds, searchParams, currentPage, dispatch]);

  return (
    <PageLayout>
      <PageHeader title={'Reviews'} />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={orderByFilter}
          >
            <ListViewButtons align='right' defaultType={DEFAULT_VIEW} />
            <MenuTags />
          </Filter>
        </Wrapper>

        <List limit={LIMIT} pagination={true} type={listType} />

        <NewCategory />
        <EditCategory />
        <CategoriesSettings />
      </div>
    </PageLayout>
  );
}

export default PacksReviews;
